/* eslint-disable no-undef */
export type CustomTealiumEventType = {
  name: string;
  label: string;
};

type WindowWithUtag = Window &
  typeof globalThis & {
    utag?: any;
  };

export const fireCustomTealiumEvent = ({ name, label }: CustomTealiumEventType): void => {
  //tealium is blocked by adblockers, hence utag will be undefined
  return (window as WindowWithUtag).utag?.link({
    content_id: `${name}-${label}`,
    tealium_event: name,
    event_label: label,
  });
};
